import { render, staticRenderFns } from "./ViewProductCategory.vue?vue&type=template&id=19ed5eb6&scoped=true&"
import script from "./ViewProductCategory.vue?vue&type=script&lang=js&"
export * from "./ViewProductCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ed5eb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
